export * from './permissions';

export enum ResourceType {
  GCP_ACCOUNT = 'gcp-account',
  GCP_PROJECT = 'gcp-project',
  GCP_RESOURCE = 'gcp-resource',
  GCP_STORAGE_BUCKET = 'gcp-storage-bucket',
  GCP_COMPUTE_INSTANCE = 'gcp-compute-instance',
  GCP_SQL_INSTANCE = 'gcp-sql-instance',
  GCP_SQL_DATABASE = 'gcp-sql-database',
  GCP_PUBSUB_SUBSCRIPTION = 'gcp-pubsub-subscription',
  GCP_KUBERNETES_CLUSTER = 'gcp-kubernetes-cluster',
  GCP_CLOUD_FUNCTION = 'gcp-cloudfunction',
}

export const Location = 'gcp';

export type GCPSQLInstanceState =
  | 'RUNNABLE'
  | 'SUSPENDED'
  | 'PENDING_DELETE'
  | 'PENDING_CREATE'
  | 'MAINTENANCE'
  | 'FAILED'
  | 'ONLINE_MAINTENANCE';


export enum GCPResourceAnnotations {
  LOCATION = 'cloud.google.com/location',
  LOCATION_ZONE = 'cloud.google.com/location-zone',
  PROJECT_NAME = 'cloud.google.com/project-name',
  PROJECT_NAMESPACE = 'cloud.google.com/project-namespace',
  PROJECT_ID = 'cloud.google.com/project-id',
  PROJECT_NUMBER = 'cloud.google.com/project-number',
  RESOURCE_STATE = 'cloud.google.com/state',
  RESOURCE_STATE_MESSAGE = 'cloud.google.com/resource-state-message',
  RESOURCE_TIME_CREATED = 'cloud.google.com/resource-time-created',
  RESOURCE_TIME_UPDATED = 'cloud.google.com/resource-time-updated',


  TIME_CREATED = 'cloud.google.com/time-created',

  // STORAGE_BUCKET
  STORAGE_CLASS = 'cloud.google.com/storage-class',
  STORAGE_VERSIONING = 'cloud.google.com/storage-versioning',

  // SQL_INSTANCE

  SQL_INSTANCE = 'cloud.google.com/sql-instance',
  SQL_INSTANCE_STATE = 'cloud.google.com/sql-instance-state',
  SQL_INSTANCE_TIER = 'cloud.google.com/sql-instance-tier',
  SQL_INSTANCE_PRICING_PLAN = 'cloud.google.com/sql-instance-pricing-plan',
  SQL_INSTANCE_VERSION = 'cloud.google.com/sql-instance-version',
  SQL_INSTANCE_REPLICATION = 'cloud.google.com/sql-instance-replication',
  SQL_INSTANCE_AVAILABILITY = 'cloud.google.com/sql-instance-availability',
  SQL_INSTANCE_DATADISK_SIZE = 'cloud.google.com/sql-instance-datadisk-size',
  SQL_INSTANCE_DELETION_PROTECTION = 'cloud.google.com/sql-instance-deletion-protection',
  SQL_INSTANCE_EDITION = 'cloud.google.com/sql-instance-edition',
  SQL_INSTANCE_STORAGE_AUTOSIZE = 'cloud.google.com/sql-instance-storage-autosize',
  SQL_INSTANCE_STORAGE_AUTOSIZE_LIMIT = 'cloud.google.com/sql-instance-storage-autosize-limit',
  SQL_INSTANCE_CONNECTION_NAME = 'cloud.google.com/sql-instance-connection-name',
  SQL_INSTANCE_IP_PRIVATE = 'cloud.google.com/sql-instance-ip-private',
  SQL_INSTANCE_IP_OUTGOING = 'cloud.google.com/sql-instance-ip-outgoing',
  SQL_INSTANCE_IP_PRIMARY = 'cloud.google.com/sql-instance-ip-primary',
  SQL_INSTANCE_DATADISK_TYPE = 'cloud.google.com/sql-instance-datadisk-type',
  SQL_INSTANCE_TRANSACTION_LOG_RETENTION_DAYS = 'cloud.google.com/sql-instance-transaction-log-retention-days',
  SQL_INSTANCE_BACKUP_ENABLED = 'cloud.google.com/sql-instance-backup-enabled',
  SQL_INSTANCE_BACKUP_START_TIME = 'cloud.google.com/sql-instance-backup-start-time',
  SQL_INSTANCE_BACKUP_RETENTION = 'cloud.google.com/sql-instance-backup-retention',




  // SQL_DATABASE

  SQL_DATABASE = 'cloud.google.com/sql-database',
  SQL_DATABASE_CHARSET = 'cloud.google.com/sql-database-charset',
  SQL_DATABASE_COLLATION = 'cloud.google.com/sql-database-collation',
}
